import { assertValue } from '@libs/utils';

import type { PriceMaskBoundaries } from '../models';
import { PriceMaskType } from '../models';

export function getPriceMaskType(
  priceMaskBoundaries: PriceMaskBoundaries,
  price: number
): PriceMaskType {
  if (price <= priceMaskBoundaries.cheap) {
    return PriceMaskType.Cheap;
  }
  if (price <= priceMaskBoundaries.moderate) {
    return PriceMaskType.Moderate;
  }
  return PriceMaskType.Expensive;
}

export function calculatePriceMaskBoundries(
  prices: number[]
): PriceMaskBoundaries {
  if (prices.length === 0) {
    return { cheap: 0, moderate: 0 };
  }

  const sortedPrices = [...prices].sort((a, b) => a - b);
  const cheapestPrice = sortedPrices[0];
  assertValue(
    cheapestPrice,
    'priceCalendarLogic.ts > calculatePriceMaskBoundries > cheapestPrice'
  );

  const mean = prices.reduce((sum, price) => sum + price, 0) / prices.length;
  const variance =
    prices.reduce((sum, price) => sum + Math.pow(price - mean, 2), 0) /
    prices.length;
  const standardDeviation = Math.sqrt(variance);

  const cheapBoundry = Math.floor(mean - standardDeviation);
  const moderateBoundry = Math.floor(mean + standardDeviation);

  return {
    cheap: cheapBoundry < cheapestPrice ? cheapestPrice : cheapBoundry,
    moderate: moderateBoundry,
  };
}
